import APITest from "./apitest/";

const Browser = {
  APITest
};

export default Browser;
